import { render } from "./ContentView.vue?vue&type=template&id=25f68d68&scoped=true"
const script = {}

import "./ContentView.vue?vue&type=style&index=0&id=25f68d68&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f68d68"]])

export default __exports__